"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Centered = Centered;
exports.BoolCell = BoolCell;
exports.ColorCell = ColorCell;
exports.TextCell = TextCell;
exports.OptionalTextCell = OptionalTextCell;
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
/**
 * Komórki tabel panelu administracyjnego.
 *
 * PO CO: FilterableTable renderuje `objectAttributeToShow` przez String(), więc
 * wartość logiczna wyświetliłaby się jako "true"/"false". Poza tym nagłówki kolumn
 * są wyśrodkowane (ResultSetTable), a treść komórek domyślnie nie - dlatego każdą
 * komórkę panelu wyśrodkowujemy, żeby nagłówek zgadzał się z wartością.
 */
/** Wyśrodkowanie treści komórki pod wyśrodkowanym nagłówkiem. */
function Centered({ children }) {
    return react_1.default.createElement("div", { className: "text-center" }, children);
}
/** Wartość logiczna jako czytelny znacznik. */
function BoolCell({ value }) {
    return (react_1.default.createElement(Centered, null, value ? (react_1.default.createElement(react_bootstrap_1.Badge, { bg: "success" }, "Tak")) : (react_1.default.createElement(react_bootstrap_1.Badge, { bg: "light", text: "dark" }, "Nie"))));
}
/** Próbka koloru z kodem obok - sam kod szesnastkowy nic nie mówi. */
function ColorCell({ value }) {
    if (!value)
        return (react_1.default.createElement(Centered, null,
            react_1.default.createElement("span", { className: "text-muted" }, "brak")));
    return (react_1.default.createElement(Centered, null,
        react_1.default.createElement("span", { className: "d-inline-flex align-items-center gap-2" },
            react_1.default.createElement("span", { style: {
                    width: 16,
                    height: 16,
                    borderRadius: 4,
                    backgroundColor: value,
                    border: "1px solid rgba(0,0,0,.2)",
                    display: "inline-block",
                } }),
            react_1.default.createElement("span", { className: "font-monospace small" }, value))));
}
/** Zwykły tekst, wyśrodkowany jak nagłówek. */
function TextCell({ value }) {
    return react_1.default.createElement(Centered, null, value);
}
/** Tekst opcjonalny: brak wartości zostawia pustą komórkę, bez wypełniacza. */
function OptionalTextCell({ value }) {
    return react_1.default.createElement(Centered, null, value ?? "");
}
